// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.5
//   protoc               v7.34.1
// source: variant.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import Long from "long";
import { Timestamp } from "./google/protobuf/timestamp";

export const protobufPackage = "variant";

export interface Attribute {
  id: string;
  name: string;
  attributeType: string;
  archived: boolean;
  references: AttributeReferences | undefined;
  createdAt: Date | undefined;
  createdBy: string;
  updatedAt?: Date | undefined;
  updatedBy?: string | undefined;
}

export interface Variant {
  id: string;
  name: string;
  isDefault: boolean;
  createdAt: Date | undefined;
  createdBy: string;
  updatedAt?: Date | undefined;
  updatedBy?: string | undefined;
}

export interface Variants {
  variants: Variant[];
}

export interface VariantManagement {
  variants: Variant[];
  attributes: Attribute[];
  variantAttributeValues: VariantAttributeValues | undefined;
}

export interface VariantAttributeValues {
  values: { [key: string]: AttributeValues };
}

export interface VariantAttributeValues_ValuesEntry {
  key: string;
  value: AttributeValues | undefined;
}

export interface AttributeValues {
  values: { [key: string]: string };
}

export interface AttributeValues_ValuesEntry {
  key: string;
  value: string;
}

/**
 * used to upsert attributes across all variants
 * value represents the value of the attribute for the variant
 */
export interface VariantValues {
  values: { [key: string]: string };
}

export interface VariantValues_ValuesEntry {
  key: string;
  value: string;
}

export interface AttributeReferences {
  topics: { [key: string]: boolean };
  flowSteps: { [key: string]: boolean };
  noCodeSteps: { [key: string]: boolean };
}

export interface AttributeReferences_TopicsEntry {
  key: string;
  value: boolean;
}

export interface AttributeReferences_FlowStepsEntry {
  key: string;
  value: boolean;
}

export interface AttributeReferences_NoCodeStepsEntry {
  key: string;
  value: boolean;
}

/** commands */
export interface VariantCreateVariant {
  id: string;
  name: string;
  attributeValues: AttributeValues | undefined;
}

export interface VariantUpdateVariant {
  id: string;
  name?: string | undefined;
  attributeValues?: AttributeValues | undefined;
}

/**
 * since variants are not referenced, we can just delete them.
 * only attributes are referenced (e.g. in topics)
 */
export interface VariantDeleteVariant {
  id: string;
}

export interface VariantCreateAttribute {
  id: string;
  name: string;
  references: AttributeReferences | undefined;
  variantValues: VariantValues | undefined;
}

export interface VariantUpdateAttribute {
  id: string;
  name?: string | undefined;
  references?: AttributeReferences | undefined;
  variantValues?: VariantValues | undefined;
}

export interface VariantDeleteAttribute {
  id: string;
}

export interface VariantSetDefaultVariant {
  id: string;
}

export interface VariantImportVariantForCsv {
  id: string;
  name: string;
  isDefault: boolean;
}

export interface VariantImportAttributeForCsv {
  id: string;
  name: string;
  references: AttributeReferences | undefined;
}

export interface VariantImportVariantAttributeValuesForCsv {
  variantId: string;
  attributeId: string;
  value: string;
}

export interface VariantImportVariants {
  variants: VariantImportVariantForCsv[];
  attributes: VariantImportAttributeForCsv[];
  variantAttributeValues: VariantImportVariantAttributeValuesForCsv[];
  deletedVariantIds: string[];
  deletedAttributeIds: string[];
}

function createBaseAttribute(): Attribute {
  return {
    id: "",
    name: "",
    attributeType: "",
    archived: false,
    references: undefined,
    createdAt: undefined,
    createdBy: "",
    updatedAt: undefined,
    updatedBy: undefined,
  };
}

export const Attribute: MessageFns<Attribute> = {
  encode(message: Attribute, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.attributeType !== "") {
      writer.uint32(26).string(message.attributeType);
    }
    if (message.archived !== false) {
      writer.uint32(72).bool(message.archived);
    }
    if (message.references !== undefined) {
      AttributeReferences.encode(message.references, writer.uint32(34).fork()).join();
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(42).fork()).join();
    }
    if (message.createdBy !== "") {
      writer.uint32(50).string(message.createdBy);
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(58).fork()).join();
    }
    if (message.updatedBy !== undefined) {
      writer.uint32(66).string(message.updatedBy);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Attribute {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAttribute();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.attributeType = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.archived = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.references = AttributeReferences.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.createdBy = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.updatedBy = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Attribute {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      attributeType: isSet(object.attributeType)
        ? globalThis.String(object.attributeType)
        : isSet(object.attribute_type)
        ? globalThis.String(object.attribute_type)
        : "",
      archived: isSet(object.archived) ? globalThis.Boolean(object.archived) : false,
      references: isSet(object.references) ? AttributeReferences.fromJSON(object.references) : undefined,
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
      createdBy: isSet(object.createdBy)
        ? globalThis.String(object.createdBy)
        : isSet(object.created_by)
        ? globalThis.String(object.created_by)
        : "",
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
      updatedBy: isSet(object.updatedBy)
        ? globalThis.String(object.updatedBy)
        : isSet(object.updated_by)
        ? globalThis.String(object.updated_by)
        : undefined,
    };
  },

  toJSON(message: Attribute): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.attributeType !== "") {
      obj.attributeType = message.attributeType;
    }
    if (message.archived !== false) {
      obj.archived = message.archived;
    }
    if (message.references !== undefined) {
      obj.references = AttributeReferences.toJSON(message.references);
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.createdBy !== "") {
      obj.createdBy = message.createdBy;
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    if (message.updatedBy !== undefined) {
      obj.updatedBy = message.updatedBy;
    }
    return obj;
  },

  create(base?: DeepPartial<Attribute>): Attribute {
    return Attribute.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<Attribute>): Attribute {
    const message = createBaseAttribute();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.attributeType = object.attributeType ?? "";
    message.archived = object.archived ?? false;
    message.references = (object.references !== undefined && object.references !== null)
      ? AttributeReferences.fromPartial(object.references)
      : undefined;
    message.createdAt = object.createdAt ?? undefined;
    message.createdBy = object.createdBy ?? "";
    message.updatedAt = object.updatedAt ?? undefined;
    message.updatedBy = object.updatedBy ?? undefined;
    return message;
  },
};

function createBaseVariant(): Variant {
  return {
    id: "",
    name: "",
    isDefault: false,
    createdAt: undefined,
    createdBy: "",
    updatedAt: undefined,
    updatedBy: undefined,
  };
}

export const Variant: MessageFns<Variant> = {
  encode(message: Variant, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.isDefault !== false) {
      writer.uint32(40).bool(message.isDefault);
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(50).fork()).join();
    }
    if (message.createdBy !== "") {
      writer.uint32(58).string(message.createdBy);
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(66).fork()).join();
    }
    if (message.updatedBy !== undefined) {
      writer.uint32(74).string(message.updatedBy);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Variant {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVariant();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.isDefault = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.createdBy = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.updatedBy = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Variant {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      isDefault: isSet(object.isDefault)
        ? globalThis.Boolean(object.isDefault)
        : isSet(object.is_default)
        ? globalThis.Boolean(object.is_default)
        : false,
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
      createdBy: isSet(object.createdBy)
        ? globalThis.String(object.createdBy)
        : isSet(object.created_by)
        ? globalThis.String(object.created_by)
        : "",
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
      updatedBy: isSet(object.updatedBy)
        ? globalThis.String(object.updatedBy)
        : isSet(object.updated_by)
        ? globalThis.String(object.updated_by)
        : undefined,
    };
  },

  toJSON(message: Variant): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.isDefault !== false) {
      obj.isDefault = message.isDefault;
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.createdBy !== "") {
      obj.createdBy = message.createdBy;
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    if (message.updatedBy !== undefined) {
      obj.updatedBy = message.updatedBy;
    }
    return obj;
  },

  create(base?: DeepPartial<Variant>): Variant {
    return Variant.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<Variant>): Variant {
    const message = createBaseVariant();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.isDefault = object.isDefault ?? false;
    message.createdAt = object.createdAt ?? undefined;
    message.createdBy = object.createdBy ?? "";
    message.updatedAt = object.updatedAt ?? undefined;
    message.updatedBy = object.updatedBy ?? undefined;
    return message;
  },
};

function createBaseVariants(): Variants {
  return { variants: [] };
}

export const Variants: MessageFns<Variants> = {
  encode(message: Variants, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.variants) {
      Variant.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Variants {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVariants();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.variants.push(Variant.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Variants {
    return {
      variants: globalThis.Array.isArray(object?.variants) ? object.variants.map((e: any) => Variant.fromJSON(e)) : [],
    };
  },

  toJSON(message: Variants): unknown {
    const obj: any = {};
    if (message.variants?.length) {
      obj.variants = message.variants.map((e) => Variant.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<Variants>): Variants {
    return Variants.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<Variants>): Variants {
    const message = createBaseVariants();
    message.variants = object.variants?.map((e) => Variant.fromPartial(e)) || [];
    return message;
  },
};

function createBaseVariantManagement(): VariantManagement {
  return { variants: [], attributes: [], variantAttributeValues: undefined };
}

export const VariantManagement: MessageFns<VariantManagement> = {
  encode(message: VariantManagement, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.variants) {
      Variant.encode(v!, writer.uint32(10).fork()).join();
    }
    for (const v of message.attributes) {
      Attribute.encode(v!, writer.uint32(18).fork()).join();
    }
    if (message.variantAttributeValues !== undefined) {
      VariantAttributeValues.encode(message.variantAttributeValues, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VariantManagement {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVariantManagement();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.variants.push(Variant.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.attributes.push(Attribute.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.variantAttributeValues = VariantAttributeValues.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VariantManagement {
    return {
      variants: globalThis.Array.isArray(object?.variants) ? object.variants.map((e: any) => Variant.fromJSON(e)) : [],
      attributes: globalThis.Array.isArray(object?.attributes)
        ? object.attributes.map((e: any) => Attribute.fromJSON(e))
        : [],
      variantAttributeValues: isSet(object.variantAttributeValues)
        ? VariantAttributeValues.fromJSON(object.variantAttributeValues)
        : isSet(object.variant_attribute_values)
        ? VariantAttributeValues.fromJSON(object.variant_attribute_values)
        : undefined,
    };
  },

  toJSON(message: VariantManagement): unknown {
    const obj: any = {};
    if (message.variants?.length) {
      obj.variants = message.variants.map((e) => Variant.toJSON(e));
    }
    if (message.attributes?.length) {
      obj.attributes = message.attributes.map((e) => Attribute.toJSON(e));
    }
    if (message.variantAttributeValues !== undefined) {
      obj.variantAttributeValues = VariantAttributeValues.toJSON(message.variantAttributeValues);
    }
    return obj;
  },

  create(base?: DeepPartial<VariantManagement>): VariantManagement {
    return VariantManagement.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<VariantManagement>): VariantManagement {
    const message = createBaseVariantManagement();
    message.variants = object.variants?.map((e) => Variant.fromPartial(e)) || [];
    message.attributes = object.attributes?.map((e) => Attribute.fromPartial(e)) || [];
    message.variantAttributeValues =
      (object.variantAttributeValues !== undefined && object.variantAttributeValues !== null)
        ? VariantAttributeValues.fromPartial(object.variantAttributeValues)
        : undefined;
    return message;
  },
};

function createBaseVariantAttributeValues(): VariantAttributeValues {
  return { values: {} };
}

export const VariantAttributeValues: MessageFns<VariantAttributeValues> = {
  encode(message: VariantAttributeValues, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    globalThis.Object.entries(message.values).forEach(([key, value]: [string, AttributeValues]) => {
      VariantAttributeValues_ValuesEntry.encode({ key: key as any, value }, writer.uint32(10).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VariantAttributeValues {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVariantAttributeValues();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          const entry1 = VariantAttributeValues_ValuesEntry.decode(reader, reader.uint32());
          if (entry1.value !== undefined) {
            message.values[entry1.key] = entry1.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VariantAttributeValues {
    return {
      values: isObject(object.values)
        ? (globalThis.Object.entries(object.values) as [string, any][]).reduce(
          (acc: { [key: string]: AttributeValues }, [key, value]: [string, any]) => {
            acc[key] = AttributeValues.fromJSON(value);
            return acc;
          },
          {},
        )
        : {},
    };
  },

  toJSON(message: VariantAttributeValues): unknown {
    const obj: any = {};
    if (message.values) {
      const entries = globalThis.Object.entries(message.values) as [string, AttributeValues][];
      if (entries.length > 0) {
        obj.values = {};
        entries.forEach(([k, v]) => {
          obj.values[k] = AttributeValues.toJSON(v);
        });
      }
    }
    return obj;
  },

  create(base?: DeepPartial<VariantAttributeValues>): VariantAttributeValues {
    return VariantAttributeValues.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<VariantAttributeValues>): VariantAttributeValues {
    const message = createBaseVariantAttributeValues();
    message.values = (globalThis.Object.entries(object.values ?? {}) as [string, AttributeValues][]).reduce(
      (acc: { [key: string]: AttributeValues }, [key, value]: [string, AttributeValues]) => {
        if (value !== undefined) {
          acc[key] = AttributeValues.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBaseVariantAttributeValues_ValuesEntry(): VariantAttributeValues_ValuesEntry {
  return { key: "", value: undefined };
}

export const VariantAttributeValues_ValuesEntry: MessageFns<VariantAttributeValues_ValuesEntry> = {
  encode(message: VariantAttributeValues_ValuesEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      AttributeValues.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VariantAttributeValues_ValuesEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVariantAttributeValues_ValuesEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = AttributeValues.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VariantAttributeValues_ValuesEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? AttributeValues.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: VariantAttributeValues_ValuesEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = AttributeValues.toJSON(message.value);
    }
    return obj;
  },

  create(base?: DeepPartial<VariantAttributeValues_ValuesEntry>): VariantAttributeValues_ValuesEntry {
    return VariantAttributeValues_ValuesEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<VariantAttributeValues_ValuesEntry>): VariantAttributeValues_ValuesEntry {
    const message = createBaseVariantAttributeValues_ValuesEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? AttributeValues.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseAttributeValues(): AttributeValues {
  return { values: {} };
}

export const AttributeValues: MessageFns<AttributeValues> = {
  encode(message: AttributeValues, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    globalThis.Object.entries(message.values).forEach(([key, value]: [string, string]) => {
      AttributeValues_ValuesEntry.encode({ key: key as any, value }, writer.uint32(10).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AttributeValues {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAttributeValues();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          const entry1 = AttributeValues_ValuesEntry.decode(reader, reader.uint32());
          if (entry1.value !== undefined) {
            message.values[entry1.key] = entry1.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AttributeValues {
    return {
      values: isObject(object.values)
        ? (globalThis.Object.entries(object.values) as [string, any][]).reduce(
          (acc: { [key: string]: string }, [key, value]: [string, any]) => {
            acc[key] = globalThis.String(value);
            return acc;
          },
          {},
        )
        : {},
    };
  },

  toJSON(message: AttributeValues): unknown {
    const obj: any = {};
    if (message.values) {
      const entries = globalThis.Object.entries(message.values) as [string, string][];
      if (entries.length > 0) {
        obj.values = {};
        entries.forEach(([k, v]) => {
          obj.values[k] = v;
        });
      }
    }
    return obj;
  },

  create(base?: DeepPartial<AttributeValues>): AttributeValues {
    return AttributeValues.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AttributeValues>): AttributeValues {
    const message = createBaseAttributeValues();
    message.values = (globalThis.Object.entries(object.values ?? {}) as [string, string][]).reduce(
      (acc: { [key: string]: string }, [key, value]: [string, string]) => {
        if (value !== undefined) {
          acc[key] = globalThis.String(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBaseAttributeValues_ValuesEntry(): AttributeValues_ValuesEntry {
  return { key: "", value: "" };
}

export const AttributeValues_ValuesEntry: MessageFns<AttributeValues_ValuesEntry> = {
  encode(message: AttributeValues_ValuesEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== "") {
      writer.uint32(18).string(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AttributeValues_ValuesEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAttributeValues_ValuesEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AttributeValues_ValuesEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.String(object.value) : "",
    };
  },

  toJSON(message: AttributeValues_ValuesEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== "") {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<AttributeValues_ValuesEntry>): AttributeValues_ValuesEntry {
    return AttributeValues_ValuesEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AttributeValues_ValuesEntry>): AttributeValues_ValuesEntry {
    const message = createBaseAttributeValues_ValuesEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? "";
    return message;
  },
};

function createBaseVariantValues(): VariantValues {
  return { values: {} };
}

export const VariantValues: MessageFns<VariantValues> = {
  encode(message: VariantValues, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    globalThis.Object.entries(message.values).forEach(([key, value]: [string, string]) => {
      VariantValues_ValuesEntry.encode({ key: key as any, value }, writer.uint32(10).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VariantValues {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVariantValues();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          const entry1 = VariantValues_ValuesEntry.decode(reader, reader.uint32());
          if (entry1.value !== undefined) {
            message.values[entry1.key] = entry1.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VariantValues {
    return {
      values: isObject(object.values)
        ? (globalThis.Object.entries(object.values) as [string, any][]).reduce(
          (acc: { [key: string]: string }, [key, value]: [string, any]) => {
            acc[key] = globalThis.String(value);
            return acc;
          },
          {},
        )
        : {},
    };
  },

  toJSON(message: VariantValues): unknown {
    const obj: any = {};
    if (message.values) {
      const entries = globalThis.Object.entries(message.values) as [string, string][];
      if (entries.length > 0) {
        obj.values = {};
        entries.forEach(([k, v]) => {
          obj.values[k] = v;
        });
      }
    }
    return obj;
  },

  create(base?: DeepPartial<VariantValues>): VariantValues {
    return VariantValues.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<VariantValues>): VariantValues {
    const message = createBaseVariantValues();
    message.values = (globalThis.Object.entries(object.values ?? {}) as [string, string][]).reduce(
      (acc: { [key: string]: string }, [key, value]: [string, string]) => {
        if (value !== undefined) {
          acc[key] = globalThis.String(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBaseVariantValues_ValuesEntry(): VariantValues_ValuesEntry {
  return { key: "", value: "" };
}

export const VariantValues_ValuesEntry: MessageFns<VariantValues_ValuesEntry> = {
  encode(message: VariantValues_ValuesEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== "") {
      writer.uint32(18).string(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VariantValues_ValuesEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVariantValues_ValuesEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VariantValues_ValuesEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.String(object.value) : "",
    };
  },

  toJSON(message: VariantValues_ValuesEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== "") {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<VariantValues_ValuesEntry>): VariantValues_ValuesEntry {
    return VariantValues_ValuesEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<VariantValues_ValuesEntry>): VariantValues_ValuesEntry {
    const message = createBaseVariantValues_ValuesEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? "";
    return message;
  },
};

function createBaseAttributeReferences(): AttributeReferences {
  return { topics: {}, flowSteps: {}, noCodeSteps: {} };
}

export const AttributeReferences: MessageFns<AttributeReferences> = {
  encode(message: AttributeReferences, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    globalThis.Object.entries(message.topics).forEach(([key, value]: [string, boolean]) => {
      AttributeReferences_TopicsEntry.encode({ key: key as any, value }, writer.uint32(10).fork()).join();
    });
    globalThis.Object.entries(message.flowSteps).forEach(([key, value]: [string, boolean]) => {
      AttributeReferences_FlowStepsEntry.encode({ key: key as any, value }, writer.uint32(18).fork()).join();
    });
    globalThis.Object.entries(message.noCodeSteps).forEach(([key, value]: [string, boolean]) => {
      AttributeReferences_NoCodeStepsEntry.encode({ key: key as any, value }, writer.uint32(26).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AttributeReferences {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAttributeReferences();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          const entry1 = AttributeReferences_TopicsEntry.decode(reader, reader.uint32());
          if (entry1.value !== undefined) {
            message.topics[entry1.key] = entry1.value;
          }
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          const entry2 = AttributeReferences_FlowStepsEntry.decode(reader, reader.uint32());
          if (entry2.value !== undefined) {
            message.flowSteps[entry2.key] = entry2.value;
          }
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          const entry3 = AttributeReferences_NoCodeStepsEntry.decode(reader, reader.uint32());
          if (entry3.value !== undefined) {
            message.noCodeSteps[entry3.key] = entry3.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AttributeReferences {
    return {
      topics: isObject(object.topics)
        ? (globalThis.Object.entries(object.topics) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
      flowSteps: isObject(object.flowSteps)
        ? (globalThis.Object.entries(object.flowSteps) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : isObject(object.flow_steps)
        ? (globalThis.Object.entries(object.flow_steps) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
      noCodeSteps: isObject(object.noCodeSteps)
        ? (globalThis.Object.entries(object.noCodeSteps) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : isObject(object.no_code_steps)
        ? (globalThis.Object.entries(object.no_code_steps) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
    };
  },

  toJSON(message: AttributeReferences): unknown {
    const obj: any = {};
    if (message.topics) {
      const entries = globalThis.Object.entries(message.topics) as [string, boolean][];
      if (entries.length > 0) {
        obj.topics = {};
        entries.forEach(([k, v]) => {
          obj.topics[k] = v;
        });
      }
    }
    if (message.flowSteps) {
      const entries = globalThis.Object.entries(message.flowSteps) as [string, boolean][];
      if (entries.length > 0) {
        obj.flowSteps = {};
        entries.forEach(([k, v]) => {
          obj.flowSteps[k] = v;
        });
      }
    }
    if (message.noCodeSteps) {
      const entries = globalThis.Object.entries(message.noCodeSteps) as [string, boolean][];
      if (entries.length > 0) {
        obj.noCodeSteps = {};
        entries.forEach(([k, v]) => {
          obj.noCodeSteps[k] = v;
        });
      }
    }
    return obj;
  },

  create(base?: DeepPartial<AttributeReferences>): AttributeReferences {
    return AttributeReferences.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AttributeReferences>): AttributeReferences {
    const message = createBaseAttributeReferences();
    message.topics = (globalThis.Object.entries(object.topics ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    message.flowSteps = (globalThis.Object.entries(object.flowSteps ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    message.noCodeSteps = (globalThis.Object.entries(object.noCodeSteps ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBaseAttributeReferences_TopicsEntry(): AttributeReferences_TopicsEntry {
  return { key: "", value: false };
}

export const AttributeReferences_TopicsEntry: MessageFns<AttributeReferences_TopicsEntry> = {
  encode(message: AttributeReferences_TopicsEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AttributeReferences_TopicsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAttributeReferences_TopicsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AttributeReferences_TopicsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: AttributeReferences_TopicsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<AttributeReferences_TopicsEntry>): AttributeReferences_TopicsEntry {
    return AttributeReferences_TopicsEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AttributeReferences_TopicsEntry>): AttributeReferences_TopicsEntry {
    const message = createBaseAttributeReferences_TopicsEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseAttributeReferences_FlowStepsEntry(): AttributeReferences_FlowStepsEntry {
  return { key: "", value: false };
}

export const AttributeReferences_FlowStepsEntry: MessageFns<AttributeReferences_FlowStepsEntry> = {
  encode(message: AttributeReferences_FlowStepsEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AttributeReferences_FlowStepsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAttributeReferences_FlowStepsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AttributeReferences_FlowStepsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: AttributeReferences_FlowStepsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<AttributeReferences_FlowStepsEntry>): AttributeReferences_FlowStepsEntry {
    return AttributeReferences_FlowStepsEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AttributeReferences_FlowStepsEntry>): AttributeReferences_FlowStepsEntry {
    const message = createBaseAttributeReferences_FlowStepsEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseAttributeReferences_NoCodeStepsEntry(): AttributeReferences_NoCodeStepsEntry {
  return { key: "", value: false };
}

export const AttributeReferences_NoCodeStepsEntry: MessageFns<AttributeReferences_NoCodeStepsEntry> = {
  encode(message: AttributeReferences_NoCodeStepsEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AttributeReferences_NoCodeStepsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAttributeReferences_NoCodeStepsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AttributeReferences_NoCodeStepsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: AttributeReferences_NoCodeStepsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<AttributeReferences_NoCodeStepsEntry>): AttributeReferences_NoCodeStepsEntry {
    return AttributeReferences_NoCodeStepsEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AttributeReferences_NoCodeStepsEntry>): AttributeReferences_NoCodeStepsEntry {
    const message = createBaseAttributeReferences_NoCodeStepsEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseVariantCreateVariant(): VariantCreateVariant {
  return { id: "", name: "", attributeValues: undefined };
}

export const VariantCreateVariant: MessageFns<VariantCreateVariant> = {
  encode(message: VariantCreateVariant, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.attributeValues !== undefined) {
      AttributeValues.encode(message.attributeValues, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VariantCreateVariant {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVariantCreateVariant();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.attributeValues = AttributeValues.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VariantCreateVariant {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      attributeValues: isSet(object.attributeValues)
        ? AttributeValues.fromJSON(object.attributeValues)
        : isSet(object.attribute_values)
        ? AttributeValues.fromJSON(object.attribute_values)
        : undefined,
    };
  },

  toJSON(message: VariantCreateVariant): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.attributeValues !== undefined) {
      obj.attributeValues = AttributeValues.toJSON(message.attributeValues);
    }
    return obj;
  },

  create(base?: DeepPartial<VariantCreateVariant>): VariantCreateVariant {
    return VariantCreateVariant.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<VariantCreateVariant>): VariantCreateVariant {
    const message = createBaseVariantCreateVariant();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.attributeValues = (object.attributeValues !== undefined && object.attributeValues !== null)
      ? AttributeValues.fromPartial(object.attributeValues)
      : undefined;
    return message;
  },
};

function createBaseVariantUpdateVariant(): VariantUpdateVariant {
  return { id: "", name: undefined, attributeValues: undefined };
}

export const VariantUpdateVariant: MessageFns<VariantUpdateVariant> = {
  encode(message: VariantUpdateVariant, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== undefined) {
      writer.uint32(18).string(message.name);
    }
    if (message.attributeValues !== undefined) {
      AttributeValues.encode(message.attributeValues, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VariantUpdateVariant {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVariantUpdateVariant();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.attributeValues = AttributeValues.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VariantUpdateVariant {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
      attributeValues: isSet(object.attributeValues)
        ? AttributeValues.fromJSON(object.attributeValues)
        : isSet(object.attribute_values)
        ? AttributeValues.fromJSON(object.attribute_values)
        : undefined,
    };
  },

  toJSON(message: VariantUpdateVariant): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    if (message.attributeValues !== undefined) {
      obj.attributeValues = AttributeValues.toJSON(message.attributeValues);
    }
    return obj;
  },

  create(base?: DeepPartial<VariantUpdateVariant>): VariantUpdateVariant {
    return VariantUpdateVariant.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<VariantUpdateVariant>): VariantUpdateVariant {
    const message = createBaseVariantUpdateVariant();
    message.id = object.id ?? "";
    message.name = object.name ?? undefined;
    message.attributeValues = (object.attributeValues !== undefined && object.attributeValues !== null)
      ? AttributeValues.fromPartial(object.attributeValues)
      : undefined;
    return message;
  },
};

function createBaseVariantDeleteVariant(): VariantDeleteVariant {
  return { id: "" };
}

export const VariantDeleteVariant: MessageFns<VariantDeleteVariant> = {
  encode(message: VariantDeleteVariant, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VariantDeleteVariant {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVariantDeleteVariant();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VariantDeleteVariant {
    return { id: isSet(object.id) ? globalThis.String(object.id) : "" };
  },

  toJSON(message: VariantDeleteVariant): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },

  create(base?: DeepPartial<VariantDeleteVariant>): VariantDeleteVariant {
    return VariantDeleteVariant.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<VariantDeleteVariant>): VariantDeleteVariant {
    const message = createBaseVariantDeleteVariant();
    message.id = object.id ?? "";
    return message;
  },
};

function createBaseVariantCreateAttribute(): VariantCreateAttribute {
  return { id: "", name: "", references: undefined, variantValues: undefined };
}

export const VariantCreateAttribute: MessageFns<VariantCreateAttribute> = {
  encode(message: VariantCreateAttribute, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.references !== undefined) {
      AttributeReferences.encode(message.references, writer.uint32(26).fork()).join();
    }
    if (message.variantValues !== undefined) {
      VariantValues.encode(message.variantValues, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VariantCreateAttribute {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVariantCreateAttribute();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.references = AttributeReferences.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.variantValues = VariantValues.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VariantCreateAttribute {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      references: isSet(object.references) ? AttributeReferences.fromJSON(object.references) : undefined,
      variantValues: isSet(object.variantValues)
        ? VariantValues.fromJSON(object.variantValues)
        : isSet(object.variant_values)
        ? VariantValues.fromJSON(object.variant_values)
        : undefined,
    };
  },

  toJSON(message: VariantCreateAttribute): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.references !== undefined) {
      obj.references = AttributeReferences.toJSON(message.references);
    }
    if (message.variantValues !== undefined) {
      obj.variantValues = VariantValues.toJSON(message.variantValues);
    }
    return obj;
  },

  create(base?: DeepPartial<VariantCreateAttribute>): VariantCreateAttribute {
    return VariantCreateAttribute.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<VariantCreateAttribute>): VariantCreateAttribute {
    const message = createBaseVariantCreateAttribute();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.references = (object.references !== undefined && object.references !== null)
      ? AttributeReferences.fromPartial(object.references)
      : undefined;
    message.variantValues = (object.variantValues !== undefined && object.variantValues !== null)
      ? VariantValues.fromPartial(object.variantValues)
      : undefined;
    return message;
  },
};

function createBaseVariantUpdateAttribute(): VariantUpdateAttribute {
  return { id: "", name: undefined, references: undefined, variantValues: undefined };
}

export const VariantUpdateAttribute: MessageFns<VariantUpdateAttribute> = {
  encode(message: VariantUpdateAttribute, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== undefined) {
      writer.uint32(18).string(message.name);
    }
    if (message.references !== undefined) {
      AttributeReferences.encode(message.references, writer.uint32(26).fork()).join();
    }
    if (message.variantValues !== undefined) {
      VariantValues.encode(message.variantValues, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VariantUpdateAttribute {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVariantUpdateAttribute();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.references = AttributeReferences.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.variantValues = VariantValues.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VariantUpdateAttribute {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
      references: isSet(object.references) ? AttributeReferences.fromJSON(object.references) : undefined,
      variantValues: isSet(object.variantValues)
        ? VariantValues.fromJSON(object.variantValues)
        : isSet(object.variant_values)
        ? VariantValues.fromJSON(object.variant_values)
        : undefined,
    };
  },

  toJSON(message: VariantUpdateAttribute): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    if (message.references !== undefined) {
      obj.references = AttributeReferences.toJSON(message.references);
    }
    if (message.variantValues !== undefined) {
      obj.variantValues = VariantValues.toJSON(message.variantValues);
    }
    return obj;
  },

  create(base?: DeepPartial<VariantUpdateAttribute>): VariantUpdateAttribute {
    return VariantUpdateAttribute.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<VariantUpdateAttribute>): VariantUpdateAttribute {
    const message = createBaseVariantUpdateAttribute();
    message.id = object.id ?? "";
    message.name = object.name ?? undefined;
    message.references = (object.references !== undefined && object.references !== null)
      ? AttributeReferences.fromPartial(object.references)
      : undefined;
    message.variantValues = (object.variantValues !== undefined && object.variantValues !== null)
      ? VariantValues.fromPartial(object.variantValues)
      : undefined;
    return message;
  },
};

function createBaseVariantDeleteAttribute(): VariantDeleteAttribute {
  return { id: "" };
}

export const VariantDeleteAttribute: MessageFns<VariantDeleteAttribute> = {
  encode(message: VariantDeleteAttribute, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VariantDeleteAttribute {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVariantDeleteAttribute();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VariantDeleteAttribute {
    return { id: isSet(object.id) ? globalThis.String(object.id) : "" };
  },

  toJSON(message: VariantDeleteAttribute): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },

  create(base?: DeepPartial<VariantDeleteAttribute>): VariantDeleteAttribute {
    return VariantDeleteAttribute.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<VariantDeleteAttribute>): VariantDeleteAttribute {
    const message = createBaseVariantDeleteAttribute();
    message.id = object.id ?? "";
    return message;
  },
};

function createBaseVariantSetDefaultVariant(): VariantSetDefaultVariant {
  return { id: "" };
}

export const VariantSetDefaultVariant: MessageFns<VariantSetDefaultVariant> = {
  encode(message: VariantSetDefaultVariant, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VariantSetDefaultVariant {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVariantSetDefaultVariant();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VariantSetDefaultVariant {
    return { id: isSet(object.id) ? globalThis.String(object.id) : "" };
  },

  toJSON(message: VariantSetDefaultVariant): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },

  create(base?: DeepPartial<VariantSetDefaultVariant>): VariantSetDefaultVariant {
    return VariantSetDefaultVariant.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<VariantSetDefaultVariant>): VariantSetDefaultVariant {
    const message = createBaseVariantSetDefaultVariant();
    message.id = object.id ?? "";
    return message;
  },
};

function createBaseVariantImportVariantForCsv(): VariantImportVariantForCsv {
  return { id: "", name: "", isDefault: false };
}

export const VariantImportVariantForCsv: MessageFns<VariantImportVariantForCsv> = {
  encode(message: VariantImportVariantForCsv, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.isDefault !== false) {
      writer.uint32(24).bool(message.isDefault);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VariantImportVariantForCsv {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVariantImportVariantForCsv();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.isDefault = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VariantImportVariantForCsv {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      isDefault: isSet(object.isDefault)
        ? globalThis.Boolean(object.isDefault)
        : isSet(object.is_default)
        ? globalThis.Boolean(object.is_default)
        : false,
    };
  },

  toJSON(message: VariantImportVariantForCsv): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.isDefault !== false) {
      obj.isDefault = message.isDefault;
    }
    return obj;
  },

  create(base?: DeepPartial<VariantImportVariantForCsv>): VariantImportVariantForCsv {
    return VariantImportVariantForCsv.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<VariantImportVariantForCsv>): VariantImportVariantForCsv {
    const message = createBaseVariantImportVariantForCsv();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.isDefault = object.isDefault ?? false;
    return message;
  },
};

function createBaseVariantImportAttributeForCsv(): VariantImportAttributeForCsv {
  return { id: "", name: "", references: undefined };
}

export const VariantImportAttributeForCsv: MessageFns<VariantImportAttributeForCsv> = {
  encode(message: VariantImportAttributeForCsv, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.references !== undefined) {
      AttributeReferences.encode(message.references, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VariantImportAttributeForCsv {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVariantImportAttributeForCsv();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.references = AttributeReferences.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VariantImportAttributeForCsv {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      references: isSet(object.references) ? AttributeReferences.fromJSON(object.references) : undefined,
    };
  },

  toJSON(message: VariantImportAttributeForCsv): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.references !== undefined) {
      obj.references = AttributeReferences.toJSON(message.references);
    }
    return obj;
  },

  create(base?: DeepPartial<VariantImportAttributeForCsv>): VariantImportAttributeForCsv {
    return VariantImportAttributeForCsv.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<VariantImportAttributeForCsv>): VariantImportAttributeForCsv {
    const message = createBaseVariantImportAttributeForCsv();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.references = (object.references !== undefined && object.references !== null)
      ? AttributeReferences.fromPartial(object.references)
      : undefined;
    return message;
  },
};

function createBaseVariantImportVariantAttributeValuesForCsv(): VariantImportVariantAttributeValuesForCsv {
  return { variantId: "", attributeId: "", value: "" };
}

export const VariantImportVariantAttributeValuesForCsv: MessageFns<VariantImportVariantAttributeValuesForCsv> = {
  encode(message: VariantImportVariantAttributeValuesForCsv, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.variantId !== "") {
      writer.uint32(10).string(message.variantId);
    }
    if (message.attributeId !== "") {
      writer.uint32(18).string(message.attributeId);
    }
    if (message.value !== "") {
      writer.uint32(26).string(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VariantImportVariantAttributeValuesForCsv {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVariantImportVariantAttributeValuesForCsv();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.variantId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.attributeId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.value = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VariantImportVariantAttributeValuesForCsv {
    return {
      variantId: isSet(object.variantId)
        ? globalThis.String(object.variantId)
        : isSet(object.variant_id)
        ? globalThis.String(object.variant_id)
        : "",
      attributeId: isSet(object.attributeId)
        ? globalThis.String(object.attributeId)
        : isSet(object.attribute_id)
        ? globalThis.String(object.attribute_id)
        : "",
      value: isSet(object.value) ? globalThis.String(object.value) : "",
    };
  },

  toJSON(message: VariantImportVariantAttributeValuesForCsv): unknown {
    const obj: any = {};
    if (message.variantId !== "") {
      obj.variantId = message.variantId;
    }
    if (message.attributeId !== "") {
      obj.attributeId = message.attributeId;
    }
    if (message.value !== "") {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<VariantImportVariantAttributeValuesForCsv>): VariantImportVariantAttributeValuesForCsv {
    return VariantImportVariantAttributeValuesForCsv.fromPartial(base ?? {});
  },
  fromPartial(
    object: DeepPartial<VariantImportVariantAttributeValuesForCsv>,
  ): VariantImportVariantAttributeValuesForCsv {
    const message = createBaseVariantImportVariantAttributeValuesForCsv();
    message.variantId = object.variantId ?? "";
    message.attributeId = object.attributeId ?? "";
    message.value = object.value ?? "";
    return message;
  },
};

function createBaseVariantImportVariants(): VariantImportVariants {
  return { variants: [], attributes: [], variantAttributeValues: [], deletedVariantIds: [], deletedAttributeIds: [] };
}

export const VariantImportVariants: MessageFns<VariantImportVariants> = {
  encode(message: VariantImportVariants, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.variants) {
      VariantImportVariantForCsv.encode(v!, writer.uint32(10).fork()).join();
    }
    for (const v of message.attributes) {
      VariantImportAttributeForCsv.encode(v!, writer.uint32(18).fork()).join();
    }
    for (const v of message.variantAttributeValues) {
      VariantImportVariantAttributeValuesForCsv.encode(v!, writer.uint32(26).fork()).join();
    }
    for (const v of message.deletedVariantIds) {
      writer.uint32(34).string(v!);
    }
    for (const v of message.deletedAttributeIds) {
      writer.uint32(42).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VariantImportVariants {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVariantImportVariants();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.variants.push(VariantImportVariantForCsv.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.attributes.push(VariantImportAttributeForCsv.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.variantAttributeValues.push(
            VariantImportVariantAttributeValuesForCsv.decode(reader, reader.uint32()),
          );
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.deletedVariantIds.push(reader.string());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.deletedAttributeIds.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VariantImportVariants {
    return {
      variants: globalThis.Array.isArray(object?.variants)
        ? object.variants.map((e: any) => VariantImportVariantForCsv.fromJSON(e))
        : [],
      attributes: globalThis.Array.isArray(object?.attributes)
        ? object.attributes.map((e: any) => VariantImportAttributeForCsv.fromJSON(e))
        : [],
      variantAttributeValues: globalThis.Array.isArray(object?.variantAttributeValues)
        ? object.variantAttributeValues.map((e: any) => VariantImportVariantAttributeValuesForCsv.fromJSON(e))
        : globalThis.Array.isArray(object?.variant_attribute_values)
        ? object.variant_attribute_values.map((e: any) => VariantImportVariantAttributeValuesForCsv.fromJSON(e))
        : [],
      deletedVariantIds: globalThis.Array.isArray(object?.deletedVariantIds)
        ? object.deletedVariantIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.deleted_variant_ids)
        ? object.deleted_variant_ids.map((e: any) => globalThis.String(e))
        : [],
      deletedAttributeIds: globalThis.Array.isArray(object?.deletedAttributeIds)
        ? object.deletedAttributeIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.deleted_attribute_ids)
        ? object.deleted_attribute_ids.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: VariantImportVariants): unknown {
    const obj: any = {};
    if (message.variants?.length) {
      obj.variants = message.variants.map((e) => VariantImportVariantForCsv.toJSON(e));
    }
    if (message.attributes?.length) {
      obj.attributes = message.attributes.map((e) => VariantImportAttributeForCsv.toJSON(e));
    }
    if (message.variantAttributeValues?.length) {
      obj.variantAttributeValues = message.variantAttributeValues.map((e) =>
        VariantImportVariantAttributeValuesForCsv.toJSON(e)
      );
    }
    if (message.deletedVariantIds?.length) {
      obj.deletedVariantIds = message.deletedVariantIds;
    }
    if (message.deletedAttributeIds?.length) {
      obj.deletedAttributeIds = message.deletedAttributeIds;
    }
    return obj;
  },

  create(base?: DeepPartial<VariantImportVariants>): VariantImportVariants {
    return VariantImportVariants.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<VariantImportVariants>): VariantImportVariants {
    const message = createBaseVariantImportVariants();
    message.variants = object.variants?.map((e) => VariantImportVariantForCsv.fromPartial(e)) || [];
    message.attributes = object.attributes?.map((e) => VariantImportAttributeForCsv.fromPartial(e)) || [];
    message.variantAttributeValues =
      object.variantAttributeValues?.map((e) => VariantImportVariantAttributeValuesForCsv.fromPartial(e)) || [];
    message.deletedVariantIds = object.deletedVariantIds?.map((e) => e) || [];
    message.deletedAttributeIds = object.deletedAttributeIds?.map((e) => e) || [];
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Long ? string | number | Long : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function toTimestamp(date: Date): Timestamp {
  const seconds = numberToLong(Math.trunc(date.getTime() / 1_000));
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds.toNumber() || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function numberToLong(number: number) {
  return Long.fromNumber(number);
}

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
